
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CrossHatchEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (40 + layerIndex * 20) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.2 / (layerIndex + 1);
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    // Forward slash
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + spacing * 0.5, y + spacing * 0.5);
                    ctx.stroke();
                    
                    // Backward slash (hatch)
                    ctx.beginPath();
                    ctx.moveTo(x + spacing * 0.5, y);
                    ctx.lineTo(x, y + spacing * 0.5);
                    ctx.stroke();
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
